import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const authHeaders = (token) => ({ Authorization: `Bearer ${token}` });

export async function submitLead(payload) {
  const response = await axios.post(`${API_BASE}/leads`, payload);
  return response.data;
}

export async function fetchLeads(token, { status = "", search = "" } = {}) {
  const response = await axios.get(`${API_BASE}/admin/leads`, {
    headers: authHeaders(token),
    params: { status: status || undefined, search: search || undefined },
  });
  return response.data;
}

export async function updateLead(token, leadId, payload) {
  const response = await axios.patch(`${API_BASE}/admin/leads/${leadId}`, payload, { headers: authHeaders(token) });
  return response.data;
}

export async function deleteLead(token, leadId) {
  const response = await axios.delete(`${API_BASE}/admin/leads/${leadId}`, { headers: authHeaders(token) });
  return response.data;
}

export async function retryLeadNotification(token, leadId) {
  const response = await axios.post(`${API_BASE}/admin/leads/${leadId}/retry-notification`, {}, { headers: authHeaders(token) });
  return response.data;
}

export async function exportLeadsCsv(token) {
  const response = await axios.get(`${API_BASE}/admin/leads-export.csv`, {
    headers: authHeaders(token),
    responseType: "blob",
  });
  return response.data;
}